import { Button, CircularProgress, Typography } from '@material-ui/core';
import { Input, useNotificationModal } from '@room-match/shared-ui-components';
import { FrontLayout } from 'components';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { COLORS } from 'shared/constants/COLORS';
import { setTheme } from 'shared/redux/slicers/theme.slicer';
import { accountService } from 'shared/services/accountService';
import { useStyles } from './InitiateDelete.styles';
const { ERROR_BUTTON_BACKGROUND, DARK_SECONDARY_BUTTONBACKGROUND } = COLORS;

const { initiateDelete } = accountService();
const InitiateDelete = () => {
  const dispatch = useDispatch();
  const { mutateAsync, isLoading } = initiateDelete();
  const [email, setemail] = useState('');
  const classes = useStyles();
  const { handleOpen, isOpen, NotificationModal, handleSetMessage, handleChangeModalType } = useNotificationModal({
    type: 'success',
  });

  const handleDelete = () => {
    mutateAsync(
      { email },
      {
        onSuccess: () => {
          setemail('');
          handleSetMessage(
            'Account Deletion',
            'Account deletion process initiated successfully. Please check your email for further instructions.',
            'Close',
          );
          handleChangeModalType('success');
          handleOpen();
        },
        onError: () => {
          handleSetMessage('Account Deletion', 'Account deletion process failed. Please try again.', 'Close');
          handleChangeModalType('error');
          handleOpen();
        },
      },
    );
  };

  const handlechange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setemail(e.target.value);
  };

  const isEmailValid = useMemo(
    () =>
      //check if email is a valid email using regex
      RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/).test(email),
    [email],
  );

  useEffect(() => {
    dispatch(setTheme('dark'));
  }, []);

  return (
    <FrontLayout containerWidth={1000} type="new">
      <div className={classes.mainCont}>
        <div className={classes.messageCont}>
          <Typography style={{ fontWeight: 600, fontSize: 24, color: COLORS.WHITE }}>Account Deletion</Typography>
          <Typography
            style={{ fontWeight: 400, fontSize: 18, marginTop: 20, textAlign: 'center', color: COLORS.WHITE }}
          >
            Please enter the email address associated with your account to initiate the deletion process.
          </Typography>
          <Input
            margin={'normal'}
            style={{ background: 'black' }}
            className={classes.input}
            onChange={handlechange}
            value={email}
            placeholder="talent@casting.com"
          />
          <Button
            disabled={!isEmailValid || isLoading}
            onClick={handleDelete}
            variant="contained"
            style={{
              marginTop: 20,
              minWidth: 150,
              color: COLORS.WHITE,
              opacity: isEmailValid ? 1 : 0.5,
              background: isEmailValid ? ERROR_BUTTON_BACKGROUND : DARK_SECONDARY_BUTTONBACKGROUND,
            }}
          >
            {isLoading ? <CircularProgress size={24} color="inherit" /> : <Typography>Delete</Typography>}
          </Button>
        </div>
      </div>
      {isOpen ? <NotificationModal /> : <React.Fragment />}
    </FrontLayout>
  );
};

export default InitiateDelete;
